(function() { window.GUID_c6e15c33_660e_4a3b_adeb_73cf1e3cdf15 = { getGuid: function() { return "c6e15c33-660e-4a3b-adeb-73cf1e3cdf15"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Rendered({
                        selector: "body",
                        childSelector: ".accordion-games-v2",
                        callback: (accordion, e) => {
                            //const { isWallLayout } = GamesSection;
                            /*if (isWallLayout) {*/
                            WallSections.GamesSection.setObservers(accordion);
                            //GamesSection.appendFiltersCounterInTopBar();
                            //const $chips = accordion.$Content.find(".chips");
                            //if ($chips.length) {
                            //    //$chips.css({
                            //    //    top: `${Math.floor($("#section-top").outerHeight()) - 1}px`,
                            //    //});
                            //    $chips.removeClass("hiddenforced");
                            //}
                            const $allStickyHeaders = accordion.$Content.find(".item__header");
                            if ($allStickyHeaders.length) {
                                let top = CS.Views.MasterPage.TopHeight - 1;
                                const $filterChips = accordion.$Content.find(".filter-chips");
                                if ($filterChips.length) {
                                    top += $filterChips.outerHeight() - 1;
                                }
                                $allStickyHeaders.each((i, el) => {
                                    $(el).css({ top });
                                });
                            }
                            /*}*/
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=games-section.rendered.js.map
